const OperationType = {
    1: "Saatlik İşlem",
    2: "Günlük İşlem",
    3: "Haftalık İşlem",
    4: "Aylık İşlem",
    5: "Bir Kez İşlem",
    6: "Özel İşlem",
}

export default OperationType;